jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

// Badge envío gratis - umbral $150.000 COP
function addFreeShippingBadges() {
  document.querySelectorAll('.t4s-product-info__inner').forEach(function(card) {
    if (card.querySelector('.t4s-free-shipping-badge')) return;
    
var priceEl = card.querySelector('ins [ymq-b2b-variant-price]') || 
              card.querySelector('[ymq-b2b-variant-price]');
if (!priceEl) return;

// Si hay precio tachado (promoción), usar solo el precio del <ins>
var insEl = card.querySelector('.t4s-product-price ins [ymq-b2b-variant-price]');
if (insEl) {
  priceEl = insEl;
}

var priceText = priceEl.textContent.replace(/[^0-9]/g, '');
var price = parseInt(priceText, 10);
    
    if (price >= 150000) {
      var badge = document.createElement('div');
      badge.className = 't4s-free-shipping-badge';
      badge.textContent = 'Envío gratis';
      card.appendChild(badge);
    }
  });
}

document.addEventListener('DOMContentLoaded', addFreeShippingBadges);
var observer = new MutationObserver(addFreeShippingBadges);
observer.observe(document.body, { childList: true, subtree: true });
